import { AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import Swiper, { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-new-featured-properties',
  templateUrl: './new-featured-properties.component.html',
  styleUrls: ['./new-featured-properties.component.css']
})
export class NewFeaturedPropertiesComponent implements OnInit {
  @Input() property_type_id: any;
  @Input() pClass;
  propertyList: any = [];
   limit: any = 100;
  offset: any = configuration.OFFSET;
  @ViewChild('swiperContainer') swiperContainer!: ElementRef;


  swiperOptions: SwiperOptions = {
    slidesPerView: 4,
    spaceBetween: 50,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  public swiperOp: SwiperOptions = {
    slidesPerView: 3,
    direction: 'horizontal',
    navigation: true,
    hashNavigation: true,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax:true,
    breakpoints: {
      350: {
        slidesPerView: 1,
        spaceBetween: 5,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 5,
      },
      680: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      1000: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      // when window width is >= 480px
      1300: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
    }
  };
  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService) {
  }

  ngOnInit(): void {
    // console.log("property_type_id",this.property_type_id)
    this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      if (!this.elRef.nativeElement.contains(target)) {
        // this.isDropdownOpen = false;
        // this.isPriceLimitDropdownOpen = false;
      }
    });
    this.getPropertyList();
  }

  async getPropertyList() {
    let requestBody: any = {
      limit: this.limit,
      offset: this.offset,
      // is_add_featured: true
    };

    if (this.property_type_id) {
      requestBody.property_type_id = this.property_type_id
    }
  
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, requestBody);
  
    if (res && !res.error && res.data) {
      this.propertyList = res.data.rows;
    }
  }
  
  
  
  
  // ngAfterViewInit(): void {
  //   if (this.swiperContainer && this.swiperContainer.nativeElement) {
  //     const swiper = new Swiper(this.swiperContainer.nativeElement, {
  //       loop: true,
  //       slidesPerView: 3,
  //       navigation: {
  //         nextEl: '.swiper-button-next',
  //         prevEl: '.swiper-button-prev',
  //       },
  //       breakpoints: {
  //         350: {
  //           slidesPerView: 1,
  //           spaceBetween: 5,
  //         },
  //         500: {
  //           slidesPerView: 2,
  //           spaceBetween: 5,
  //         },
  //         680: {
  //           slidesPerView: 2,
  //           spaceBetween: 15,
  //         },
  //         1000: {
  //           slidesPerView: 3,
  //           spaceBetween: 15,
  //         },
  //         1300: {
  //           slidesPerView: 3,
  //           spaceBetween: 15,
  //         },
  //       }
  //     });
  //   }
  // }

  onSlideChange(){}
}
